/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright Â© 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Layout from 'components/Layout/layout.jsx';
import Home from './home.jsx';

const title =
  'スマートオーダーシリーズ | 今すぐ導入できるスマホのオーダーシステム';

async function action(context) {
  return {
    title,
    chunks: ['home'],
    component: (
      <Layout context={context}>
        <Home />
      </Layout>
    ),
  };
}

export default action;
